import { field } from "../forms/FormControls.jsx";
export function periodFields(p) {
  return p.mode === "day" ? (
    field("Specific date", "day", p.day || "", "date", "required")
  ) : p.mode === "month" ? (
    field("Month and year", "month", p.month || "", "month", "required")
  ) : p.mode === "year" ? (
    field(
      "Year",
      "year",
      p.year || "",
      "number",
      'min="1900" max="9999" step="1" required',
    )
  ) : p.mode === "range" ? (
    <>
      {field("From (inclusive)", "start", p.start || "", "date", "required")}
      {field("Through (inclusive)", "end", p.end || "", "date", "required")}
    </>
  ) : (
    <p className={"hint"}>{"All available order dates."}</p>
  );
}
